export { default } from "./DatoCmsTable";
